import { Container } from "pixi.js";
import { getMobileDetect } from "../../config/GlobalVariableConfig";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { Logo } from "./Logo";

export class LogoComponent extends AbstractDisplayComponent {
    public container: Container;

    public override init() {
        let containerConfig = {
            labelName: "logo_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: getMobileDetect() ? 340 : 376,
                posY: getMobileDetect() ? 680 : 686,
                scale: getMobileDetect() ? 0.7 : 0.8,
            },
            portrait: {
                posX: 1024,
                posY: 180,
                scale: 1.4,
            }
        };

        this.container = new Logo(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

}
